import methods from '@/services/methods'

export default {
  virtualAccountsList (payload) {
    return methods.sendGet('virtual_accounts/list', payload, {unprivilege: 'Virtual Accounts', noHyptoLoader: true})
  },
  create (payload) {
    return methods.sendPost('virtual_accounts', payload, {restrictToast: true, disableButtons: true})
  },
  update (payload, id) {
    return methods.sendPut(`virtual_accounts/${id}`, payload, {restrictToast: true, disableButtons: true})
  },
  whitelistRemitter (payload, id) {
    return methods.sendPost(`virtual_accounts/${id}/whitelist_remitter`, payload)
  },
  unwhitelistRemitter (payload, id) {
    return methods.sendPost(`virtual_accounts/${id}/unwhitelist_remitter`, payload)
  },
  exportVirtualAccounts (payload) {
    return methods.sendGet('virtual_accounts/export', payload)
  },
  exportTxns (payload, id) {
    return methods.sendGet(`virtual_accounts/${id}/export_txns`, payload)
  },
  virtualAccountDetails (id, payload) {
    return methods.sendGet(`virtual_accounts/${id}/transactions`, payload, {unprivilege: 'Virtual Account Details', noHyptoLoader: true})
  },
  search (payload) {
    return methods.sendGet('virtual_accounts/search', payload, {restrictToast: true, unprivilege: 'Virtual Accounts', noHyptoLoader: true})
  },
  bulkResendWebhook (payload, id) {
    return methods.sendPost(`virtual_accounts/${id}/bulk_resend_webhook`, payload)
  }
}
